import { __awaiter } from 'tslib';
import { Injectable, ErrorHandler, Component, NgModule } from '@angular/core';
import { UrlConfig, UrlBuilder, RequestMode, Params, IFResponse } from '@inflight/core-nlx';
import { SettingsService as SettingsService$1, Http, LastResponseService, AppInjector, EndHttpEvent, CoreNg } from '@inflight/core-ng';
import { FormGroup, FormControl, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { take, distinctUntilChanged } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@inflight/core-ng';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/platform-browser';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@ngx-translate/core';
import * as ɵngcc6 from '@angular/common';

function PSMessagesComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵlistener("click", function PSMessagesComponent_a_7_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.attachmentSelected(); });
    ɵngcc0.ɵɵtext(1, "View Attachment");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attachment_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("href", attachment_r1.url, ɵngcc0.ɵɵsanitizeUrl);
} }
class SettingsService extends SettingsService$1 {
    constructor() {
        super();
        if (window.ifConfig) {
            if (ifConfig.ext) {
                this.ext = ifConfig.ext;
            }
            if (ifConfig.nativePaths) {
                this._nativePaths = ifConfig.nativePaths;
            }
        }
    }
    getExt(key) {
        return this.ext ? this.ext[key] : undefined;
    }
    get nativePaths() {
        return this._nativePaths;
    }
}
SettingsService.ɵfac = function SettingsService_Factory(t) { return new (t || SettingsService)(); };
SettingsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SettingsService, factory: SettingsService.ɵfac });
SettingsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SettingsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PsHttp {
    constructor(http, settingsService) {
        this.http = http;
        this.settingsService = settingsService;
        this.CONFIG = PsHttp.getUrlConfig(settingsService.defaultSystemSettings);
    }
    static getUrlConfig(settings) {
        const config = new UrlConfig();
        config.isNLXCall = true;
        config.EnvironmentAlias = settings.EnvironmentAlias;
        config.InFlightId = settings.InFlightID;
        config.AdditionalParams = 'NLX7';
        config.setSSO(settings.isSSO);
        config.setSSOBounce(settings.isSSOBounce);
        if (settings.hasIFURLPrefix) {
            config.Prefix = settings.IFURLPrefix;
        }
        if (settings.hasIFURLPostfix) {
            config.Postfix = settings.IFURLPostfix;
        }
        config.IFMode = settings.IFMode;
        return config;
    }
    getSSO() {
        return this.CONFIG.SSO;
    }
    setSSO(isSSO) {
        this.CONFIG.setSSO(isSSO);
    }
    setSystem(systemKey) {
        if (!systemKey) {
            throw new Error('sysemKey is required.');
        }
        const systemSettings = this.settingsService.getSystemSettings(systemKey);
        if (!systemSettings) {
            throw new Error(`No settings exist for key '${systemKey}'.  Please check your config.general.`);
        }
        this.systemKey = systemKey;
        this.CONFIG = PsHttp.getUrlConfig(systemSettings);
    }
    get(url, followProposedRoute) {
        return __awaiter(this, void 0, void 0, function* () {
            if (followProposedRoute === undefined) {
                followProposedRoute = true;
            }
            return yield this.http.get(UrlBuilder.updateUrl(url, this.CONFIG), null, RequestMode.InFlight, followProposedRoute);
        });
    }
    post(icaction, url, bodyParams, followProposedRoute, notifyTransition) {
        return __awaiter(this, void 0, void 0, function* () {
            if (followProposedRoute === undefined) {
                followProposedRoute = true;
            }
            if (notifyTransition === undefined) {
                notifyTransition = true;
            }
            if (icaction) {
                if (bodyParams instanceof Params) {
                    bodyParams.replace(PsHttp.ICACTION, icaction);
                }
                else {
                    if (!bodyParams.get(PsHttp.ICACTION)) {
                        bodyParams.append(PsHttp.ICACTION, icaction);
                    }
                    bodyParams.set(PsHttp.ICACTION, icaction);
                }
            }
            return yield this.http.post(UrlBuilder.updateUrl(url, this.CONFIG), bodyParams, RequestMode.InFlight, followProposedRoute, notifyTransition);
        });
    }
}
PsHttp.ɵfac = function PsHttp_Factory(t) { return new (t || PsHttp)(ɵngcc0.ɵɵinject(ɵngcc1.Http), ɵngcc0.ɵɵinject(SettingsService)); };
PsHttp.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PsHttp, factory: PsHttp.ɵfac });
PsHttp.ICACTION = 'ICAction';
PsHttp.ctorParameters = () => [
    { type: Http },
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PsHttp, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Http }, { type: SettingsService }]; }, null); })();

class PsHttpFactory {
    constructor(http, psHttp, settingsService) {
        this.http = http;
        this.psHttp = psHttp;
        this.settingsService = settingsService;
    }
    system(key) {
        if (PsHttpFactory.STORE.has(key)) {
            return PsHttpFactory.STORE[key];
        }
        const instance = new PsHttp(this.http, this.settingsService);
        instance.setSystem(key);
        PsHttpFactory.STORE[key] = instance;
        return instance;
    }
    default() {
        return this.psHttp;
    }
}
PsHttpFactory.ɵfac = function PsHttpFactory_Factory(t) { return new (t || PsHttpFactory)(ɵngcc0.ɵɵinject(ɵngcc1.Http), ɵngcc0.ɵɵinject(PsHttp), ɵngcc0.ɵɵinject(SettingsService)); };
PsHttpFactory.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PsHttpFactory, factory: PsHttpFactory.ɵfac });
PsHttpFactory.STORE = new Map();
PsHttpFactory.ctorParameters = () => [
    { type: Http },
    { type: PsHttp },
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PsHttpFactory, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Http }, { type: PsHttp }, { type: SettingsService }]; }, null); })();

class PsForm {
    static getFormData(form, icaction, files) {
        const result = new FormData();
        let omit = [PsHttp.ICACTION];
        if (files) {
            const fileFormNames = Object.keys(files);
            if (fileFormNames && fileFormNames.length > 0) {
                omit = omit.concat(fileFormNames);
            }
        }
        if (form instanceof FormGroup) {
            this.addFormGroupToFormData(form, result, omit);
        }
        else if (form.constructor === Array) {
            for (const item of form) {
                this.addFormGroupToFormData(item, result, omit);
            }
        }
        if (icaction) {
            result.append(PsHttp.ICACTION, icaction);
        }
        if (files) {
            this.addFormDataToFormData(files, result);
        }
        return result;
    }
    static getFormParams(form, icaction) {
        const params = new Params();
        if (icaction) {
            params.set(PsHttp.ICACTION, icaction);
        }
        if (form instanceof FormGroup) {
            this.addFormGroupToParams(form, params, [PsHttp.ICACTION]);
        }
        else if (form.constructor === Array) {
            for (const item of form) {
                this.addFormGroupToParams(item, params, [PsHttp.ICACTION]);
            }
        }
        return params;
    }
    static setFormHiddens(form, hiddens) {
        for (const hiddenField of hiddens) {
            // Setting form.value[key] directly causes inconsistent results, so use 'addControl' instead.
            if (form.contains(hiddenField.name)) {
                form.setControl(hiddenField.name, new FormControl(hiddenField.value));
            }
            else {
                form.addControl(hiddenField.name, new FormControl(hiddenField.value));
            }
        }
    }
    static isEmpty(files) {
        if (!files) {
            return true;
        }
        return Object.keys(files).length === 0;
    }
    static addFormGroupToParams(src, dest, omit) {
        if (src && src.controls) {
            let formControlValue;
            Object.keys(src.value).forEach(keyName => {
                if (!omit || omit.indexOf(keyName) === -1) {
                    formControlValue = src.value[keyName];
                    if (formControlValue !== null && formControlValue !== undefined) {
                        dest.set(keyName, formControlValue);
                    }
                }
            });
        }
        return dest;
    }
    static addFormGroupToFormData(src, dest, omit) {
        if (src && src.controls) {
            let formControlValue;
            Object.keys(src.value).forEach(keyName => {
                if (!omit || omit.indexOf(keyName) === -1) {
                    formControlValue = src.value[keyName];
                    if (formControlValue !== null && formControlValue !== undefined) {
                        dest.append(keyName, formControlValue);
                    }
                }
            });
        }
    }
    static addFormDataToFormData(src, dest) {
        if (src) {
            const keys = Object.keys(src);
            keys.forEach(key => {
                const data = src[key];
                dest.append(key, data, data.name);
            });
        }
    }
}
PsForm.ɵfac = function PsForm_Factory(t) { return new (t || PsForm)(); };
PsForm.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PsForm, factory: PsForm.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PsForm, [{
        type: Injectable
    }], null, null); })();

class PsMessagesService {
    constructor() {
        this._attachmentSource = new Subject();
        this.attachment$ = this._attachmentSource.asObservable();
        this._errorSource = new Subject();
        this.error$ = this._errorSource.asObservable();
    }
    setAttachments(attachments) {
        attachments = this.processAttachments(attachments);
        this._attachmentSource.next(attachments);
    }
    setErrorMessage(message) {
        this._errorSource.next(message);
    }
    processAttachments(attachments) {
        // Remove NLX3|7 from the inflight portion of the url as files
        // shouldn't need to run through the transformation engine.
        if (attachments) {
            for (const attachment of attachments) {
                const nlxRegex = /(\/NLX[37])/g;
                const ifRegex = /\/--IF.*?\/FI--/;
                const ifUrlMatch = ifRegex.exec(attachment.url);
                if (ifUrlMatch && ifUrlMatch.length > 0) {
                    const ifUrlPrefix = ifUrlMatch[0];
                    attachment.url = attachment.url.replace(ifUrlPrefix, ifUrlPrefix.replace(nlxRegex, ''));
                }
            }
        }
        return attachments;
    }
}
PsMessagesService.ɵfac = function PsMessagesService_Factory(t) { return new (t || PsMessagesService)(); };
PsMessagesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PsMessagesService, factory: PsMessagesService.ɵfac });
PsMessagesService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PsMessagesService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PsFormDependenciesService {
    constructor(router, titleService, psHttp, lastService, formBuilder, psHttpFactory) {
        this.router = router;
        this.titleService = titleService;
        this.psHttp = psHttp;
        this.lastService = lastService;
        this.formBuilder = formBuilder;
        this.psHttpFactory = psHttpFactory;
    }
}
PsFormDependenciesService.ɵfac = function PsFormDependenciesService_Factory(t) { return new (t || PsFormDependenciesService)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc3.Title), ɵngcc0.ɵɵinject(PsHttp), ɵngcc0.ɵɵinject(ɵngcc1.LastResponseService), ɵngcc0.ɵɵinject(ɵngcc4.FormBuilder), ɵngcc0.ɵɵinject(PsHttpFactory)); };
PsFormDependenciesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PsFormDependenciesService, factory: PsFormDependenciesService.ɵfac });
PsFormDependenciesService.ctorParameters = () => [
    { type: Router },
    { type: Title },
    { type: PsHttp },
    { type: LastResponseService },
    { type: FormBuilder },
    { type: PsHttpFactory }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PsFormDependenciesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.Router }, { type: ɵngcc3.Title }, { type: PsHttp }, { type: ɵngcc1.LastResponseService }, { type: ɵngcc4.FormBuilder }, { type: PsHttpFactory }]; }, null); })();

class PsFormComponent {
    constructor(...params) {
        // arguments exist for backwards compatibility reasons ONLY.
        const injector = AppInjector.getInjector();
        this.formService = injector.get(PsFormDependenciesService);
        this.messageService = injector.get(PsMessagesService);
        this.form = this.formService.formBuilder.group({});
        this.files = {};
        this.router = this.formService.router; // For backwards compatibility reasons ONLY.
    }
    getTargetSystem() {
        return undefined; // default
    }
    getMode() {
        return 'page';
    }
    isPageMode() {
        return this.getMode() === 'page';
    }
    psHttp() {
        const targetSystem = this.getTargetSystem();
        if (!targetSystem || !this.formService.psHttpFactory) {
            return this.formService.psHttp;
        }
        return this.formService.psHttpFactory.system(targetSystem);
    }
    ngOnInit() {
        this.routeName = this.formService.router.url;
        const targetUrl = this.getTargetUrl();
        // Setting ngOnInit to be async makes typescript complain, so use '.then' instead of 'await'.
        const isPageMode = this.isPageMode();
        this._init(targetUrl, !isPageMode, isPageMode).then(response => {
            this._bind(response);
        });
    }
    reInit(forceNewRequest = true, followProposedTemplate = true) {
        return __awaiter(this, void 0, void 0, function* () {
            this.routeName = this.formService.router.url;
            const response = yield this._init(this.getTargetUrl(), forceNewRequest, followProposedTemplate);
            this._bind(response);
            return response;
        });
    }
    action(button, followProposedTemplate = true, url = this._getTargetUrl(), notifyTransition = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let data;
            const icaction = button ? button.id : undefined;
            if (PsForm.isEmpty(this.files)) {
                data = PsForm.getFormParams(this.form, icaction);
            }
            else {
                data = PsForm.getFormData(this.form, icaction, this.files);
            }
            const response = yield this.psHttp().post(undefined, url, data, followProposedTemplate, notifyTransition);
            this._bind(response);
            return response;
        });
    }
    updateFiles(name, file) {
        if (!file) {
            delete this.files[name];
        }
        else {
            this.files[name] = file;
        }
    }
    setHiddens(hiddens) {
        PsForm.setFormHiddens(this.form, hiddens);
    }
    _bind(response) {
        this._setTargetUrl(response);
        this.setHiddens(this.getHiddens(response));
        this.setTitle(response);
        const pageData = this._getResponsePage(response);
        this.bind(response);
        this.setAttachment(pageData);
        this.setError(pageData);
    }
    getHiddens(response) {
        if (!response || !response.Results || !response.Results.data) {
            return [];
        }
        let hiddens = response.Results.data.hiddens;
        if (!hiddens) {
            Object.keys(response.Results.data).some(key => {
                if (response.Results.data[key] && response.Results.data[key].hiddens) {
                    hiddens = response.Results.data[key].hiddens;
                    return true;
                }
            });
        }
        return hiddens ? hiddens : [];
    }
    _getResponsePage(response) {
        if (response && response.Results && response.Results.data) {
            const data = response.Results.data;
            for (const key in data) {
                if (data[key].form) {
                    return data[key];
                }
            }
        }
        else {
            return null;
        }
    }
    setAttachment(page) {
        if (page && page.attachments && page.attachments) {
            this.messageService.setAttachments(page.attachments);
        }
    }
    setError(page) {
        if (page && page.error && page.error.message) {
            this.messageService.setErrorMessage(page.error.message);
        }
    }
    setTitle(response) {
        if (!this.isPageMode()) {
            return;
        }
        if (!response || !response.Results || !response.Results.data) {
            return;
        }
        let header = response.Results.data.header;
        if (!header) {
            for (const key in response.Results.data) {
                if (response.Results.data[key].header) {
                    header = response.Results.data[key].header;
                }
            }
        }
        if (header && header.title) {
            this.formService.titleService.setTitle(header.title);
        }
    }
    _init(targetUrl, forceNewRequest, followProposedTemplate) {
        return __awaiter(this, void 0, void 0, function* () {
            if (forceNewRequest) {
                if (targetUrl === null) {
                    this.formService.router.navigateByUrl('/');
                    return;
                }
                return this.psHttp().get(targetUrl, followProposedTemplate);
            }
            const lastResponse = this.formService.lastService.ifResponse;
            if (lastResponse &&
                this.formService.router.isActive(lastResponse.ProposedTemplate, false)) {
                return Promise.resolve(lastResponse);
            }
            else {
                if (targetUrl === null) {
                    this.formService.router.navigateByUrl('/');
                    return;
                }
                return this.psHttp().get(targetUrl, followProposedTemplate);
            }
        });
    }
    _getTargetUrl() {
        if (this._targetUrl) {
            return this._targetUrl;
        }
        return this.getTargetUrl();
    }
    _setTargetUrl(ifResponse) {
        this._targetUrl = undefined;
        if (!ifResponse) {
            return;
        }
        if (!this.formService.router.isActive(ifResponse.ProposedTemplate, true)) {
            return;
        }
        let url = this.findFormAction(ifResponse);
        if (!url && ifResponse.referrer) {
            url = this.formService.lastService.getReferringTarget();
        }
        if (url && url.indexOf('/--IF/') === 0) {
            this._targetUrl = url;
        }
    }
    get activatedRoute() {
        let activatedRoute = this.formService.router.routerState.root;
        while (activatedRoute.firstChild) {
            activatedRoute = activatedRoute.firstChild;
        }
        return activatedRoute;
    }
    isMyProposedTemplate(response, ignoreQueryParams = true) {
        let routeName = ignoreQueryParams ? this.routeName.substring(0, this.routeName.indexOf('?')) : this.routeName;
        routeName = routeName || this.routeName;
        return response && routeName === response.ProposedTemplate;
    }
    findFormAction(ifResponse) {
        if (!ifResponse.Results || !ifResponse.Results.data) {
            return;
        }
        const dataEntries = Object.entries(ifResponse.Results.data);
        if (dataEntries) {
            const pageEntry = dataEntries.find(entry => entry && entry[1] && entry[1].form);
            if (pageEntry) {
                return pageEntry[1].form.action;
            }
        }
    }
}
PsFormComponent.ɵfac = function PsFormComponent_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
PsFormComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PsFormComponent });


class UserAppsData {
    constructor(settings) {
        this.settings = settings;
        this.loadAppsData();
    }
    get apps() {
        return this.appsData;
    }
    refreshAppData(data) {
        if (data) {
            this.appsData = data;
        }
        else {
            this.loadAppsData();
        }
    }
    loadAppsData() {
        this.appsData = this.settings.getExt(UserAppsData.USERAPPS);
    }
}
UserAppsData.ɵfac = function UserAppsData_Factory(t) { return new (t || UserAppsData)(ɵngcc0.ɵɵinject(SettingsService)); };
UserAppsData.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UserAppsData, factory: UserAppsData.ɵfac });
UserAppsData.USERAPPS = 'userapps';
UserAppsData.ctorParameters = () => [
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserAppsData, [{
        type: Injectable
    }], function () { return [{ type: SettingsService }]; }, null); })();

class UserAppsService {
    constructor(psHttpFactory, userAppsData, errorHandler, translateService) {
        this.psHttpFactory = psHttpFactory;
        this.userAppsData = userAppsData;
        this.errorHandler = errorHandler;
        this.translateService = translateService;
    }
    getEnabledApps() {
        return __awaiter(this, void 0, void 0, function* () {
            const appData = this.userAppsData.apps;
            const srcs = appData.srcPages;
            const appKeys = yield this.getKeysOnSrcPages(srcs);
            return this._getEnabledApps(appKeys);
        });
    }
    getKeysOnSrcPages(srcPages) {
        return __awaiter(this, void 0, void 0, function* () {
            const appKeys = [];
            if (srcPages && srcPages.length) {
                const firstSrcPage = srcPages[0];
                const firstResponse = yield this.getKeysOnSrcPage(firstSrcPage);
                try {
                    this._aggregateKeysFromResponse(firstResponse, appKeys);
                    const theRestOfTheSrcPages = srcPages.slice(1);
                    const promises = theRestOfTheSrcPages.map((srcPage) => __awaiter(this, void 0, void 0, function* () {
                        const response = yield this.getKeysOnSrcPage(srcPage);
                        this._aggregateKeysFromResponse(response, appKeys);
                    }));
                    yield Promise.all(promises).catch((e) => {
                        this.errorHandler.handleError(e);
                    });
                }
                catch (e) {
                    this.errorHandler.handleError(e);
                }
                return appKeys;
            }
        });
    }
    _aggregateKeysFromResponse(response, appKeys) {
        if (response instanceof IFResponse) {
            if (response.ProposedTemplate !== "/user-apps") {
                throw new Error("User is not logged in");
            }
            if (response.Results.data.userApps) {
                response.Results.data.userApps.forEach((key) => {
                    appKeys.push(key);
                });
            }
        }
    }
    getKeysOnSrcPage(srcPage) {
        const psHttp = srcPage && srcPage.system
            ? this.psHttpFactory.system(srcPage.system)
            : this.psHttpFactory.default();
        if (srcPage.method === "GET") {
            return psHttp.get(srcPage.uri, false);
        }
        return psHttp.post(null, srcPage.uri, new Params(), false);
    }
    _getEnabledApps(keys) {
        return __awaiter(this, void 0, void 0, function* () {
            const apps = this.userAppsData.apps.apps;
            const returnApps = [];
            const configKeys = [];
            apps.forEach((app) => {
                app.items.forEach((item) => {
                    if (item.key) {
                        configKeys.push(item.key);
                    }
                });
            });
            const text = yield this.translateService
                .get(configKeys)
                .pipe(take(1))
                .toPromise();
            apps.forEach((app) => {
                let items = null;
                if (app.items) {
                    items = app.items.filter((item) => {
                        return this.isItemEnabledOnSrcPage(item, keys, text);
                    });
                }
                if (items && items.length > 0) {
                    const cat = {
                        category: app.category,
                        theme: app.theme,
                        items: items,
                        template: app.template,
                    };
                    returnApps.push(cat);
                }
            });
            return returnApps;
        });
    }
    isItemEnabledOnSrcPage(item, keys, translation) {
        if (item.matchFn) {
            if (!item.matchFn({ keys }, translation) || !item.matchFn({ keys })) {
                // matchFn was specified and failed so no good
                return false;
            }
        }
        if (!item.key) {
            return true;
        }
        if (keys.find((key) => key.toLowerCase() === translation[item.key].toLowerCase())) {
            return true;
        }
        return false;
    }
}
UserAppsService.ɵfac = function UserAppsService_Factory(t) { return new (t || UserAppsService)(ɵngcc0.ɵɵinject(PsHttpFactory), ɵngcc0.ɵɵinject(UserAppsData), ɵngcc0.ɵɵinject(ɵngcc0.ErrorHandler), ɵngcc0.ɵɵinject(ɵngcc5.TranslateService)); };
UserAppsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UserAppsService, factory: UserAppsService.ɵfac });
UserAppsService.ctorParameters = () => [
    { type: PsHttpFactory },
    { type: UserAppsData },
    { type: ErrorHandler },
    { type: TranslateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserAppsService, [{
        type: Injectable
    }], function () { return [{ type: PsHttpFactory }, { type: UserAppsData }, { type: ɵngcc0.ErrorHandler }, { type: ɵngcc5.TranslateService }]; }, null); })();

class UserService {
    constructor(psHttp, ifHttp, userAppsService, lastResponseService, settings) {
        this.psHttp = psHttp;
        this.ifHttp = ifHttp;
        this.userAppsService = userAppsService;
        this.lastResponseService = lastResponseService;
        this.settings = settings;
        this.userAppsPromise = null;
        this.logoutPath = '?cmd=logout';
        this.loginSubject = new BehaviorSubject(this.hasValidSession());
        this.loginObservable = this.loginSubject.asObservable().pipe(distinctUntilChanged());
        ifHttp.httpEvents.subscribe(evt => {
            if (evt instanceof EndHttpEvent) {
                let isLoggedIn = false;
                if (this.hooks) {
                    isLoggedIn = this.hooks.isLoggedIn();
                }
                else {
                    // the list of proposed templates that represent a logged in state will need to grow
                    isLoggedIn =
                        lastResponseService.ifResponse.ProposedTemplate !== '/login';
                }
                if (isLoggedIn !== undefined) {
                    this.updateLoginStatus(isLoggedIn);
                }
            }
        });
        if (this.settings.nativePaths &&
            this.settings.nativePaths.logout &&
            this.settings.nativePaths.logout.length) {
            this.logoutPath = this.settings.nativePaths.logout[0];
        }
    }
    setHooks(hooks) {
        this.hooks = hooks;
    }
    hasValidSession() {
        return sessionStorage.getItem(UserService.IS_LOGGED_IN_KEY) === 'true';
    }
    updateLoginStatus(status) {
        if (status === false && this.hasValidSession()) {
            this.clearUserData();
        }
        sessionStorage.setItem(UserService.IS_LOGGED_IN_KEY, `${status}`);
        this.loginSubject.next(status);
    }
    get loginStatus() {
        return this.loginObservable;
    }
    clearUserData() {
        sessionStorage.clear();
        this.lastResponseService.clear();
        this.userAppsPromise = null;
    }
    logout() {
        this.clearUserData();
        this.updateLoginStatus(false);
        if (this.hooks) {
            this.hooks.onLogout();
        }
        else {
            this.psHttp.get(this.logoutPath);
        }
    }
    loadApps() {
        if (this.userAppsPromise !== null) {
            return this.userAppsPromise;
        }
        if (sessionStorage['enabledUserApps']) {
            const enabledUserApps = JSON.parse(sessionStorage['enabledUserApps']);
            if (enabledUserApps) {
                return Promise.resolve(enabledUserApps);
            }
        }
        this.userAppsPromise = this.userAppsService.getEnabledApps();
        this.userAppsPromise.then(apps => {
            sessionStorage['enabledUserApps'] = JSON.stringify(apps);
        });
        return this.userAppsPromise;
    }
    refreshSession(refreshQuery) {
        const ifConfig = window.ifConfig;
        const config = new UrlConfig();
        config.isNLXCall = true;
        config.Prefix = ifConfig.IFURLPrefix;
        config.EnvironmentAlias = ifConfig.EnvironmentAlias;
        config.InFlightId = ifConfig.InFlightID;
        config.Postfix = ifConfig.IFURLPostfix + refreshQuery;
        this.ifHttp.get(UrlBuilder.getBaseUrl(config), undefined, RequestMode.Raw, false, false);
    }
}
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(ɵngcc0.ɵɵinject(PsHttp), ɵngcc0.ɵɵinject(ɵngcc1.Http), ɵngcc0.ɵɵinject(UserAppsService), ɵngcc0.ɵɵinject(ɵngcc1.LastResponseService), ɵngcc0.ɵɵinject(SettingsService)); };
UserService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UserService, factory: UserService.ɵfac });
UserService.IS_LOGGED_IN_KEY = '__IS_LOGGED_IN__';
UserService.ctorParameters = () => [
    { type: PsHttp },
    { type: Http },
    { type: UserAppsService },
    { type: LastResponseService },
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserService, [{
        type: Injectable
    }], function () { return [{ type: PsHttp }, { type: ɵngcc1.Http }, { type: UserAppsService }, { type: ɵngcc1.LastResponseService }, { type: SettingsService }]; }, null); })();

class PSMessagesComponent {
    constructor(messagesService) {
        this.messagesService = messagesService;
    }
    ngOnInit() {
        this.attachmentSubscription = this.messagesService.attachment$
            .subscribe(attachments => {
            this.showAttachments(attachments);
        });
        this.errorSubscription = this.messagesService.error$
            .subscribe(error => {
            this.showError(error);
        });
    }
    showAttachments(attachments) {
        if (attachments && attachments.length) {
            this.attachments = attachments;
            $('#attachmentModal').modal('show');
        }
    }
    showError(message) {
        if (message) {
            this.errorMessage = message;
            $('#errorModal').modal('show');
        }
    }
    attachmentSelected() {
        $('#attachmentModal').modal('hide');
    }
    ngOnDestroy() {
        // prevent memory leak when component is destroyed
        this.attachmentSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
    }
}
PSMessagesComponent.ɵfac = function PSMessagesComponent_Factory(t) { return new (t || PSMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(PsMessagesService)); };
PSMessagesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PSMessagesComponent, selectors: [["ps-messages"]], decls: 18, vars: 2, consts: [["id", "attachmentModal", "tabindex", "-1", "role", "dialog", "aria-labelledby", "attachmentModalTitle", "aria-hidden", "true", 1, "modal", "fade"], ["role", "document", 1, "modal-dialog"], [1, "modal-content"], [1, "modal-header", "d-none"], ["id", "attachmentModalTitle", 1, "modal-title"], [1, "modal-body"], ["target", "_blank", "class", "btn btn-secondary btn-block mb-1", 3, "href", "click", 4, "ngFor", "ngForOf"], ["id", "errorModal", "tabindex", "-1", "role", "dialog", "aria-labelledby", "errorModalTitle", "aria-hidden", "true", 1, "modal", "fade"], ["role", "document", 1, "modal-dialog", "modal-dialog-centered"], ["id", "errorModalTitle", 1, "modal-title"], [1, "modal-body", 3, "innerHTML"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary"], ["target", "_blank", 1, "btn", "btn-secondary", "btn-block", "mb-1", 3, "href", "click"]], template: function PSMessagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h5", 4);
        ɵngcc0.ɵɵtext(5, "Attachments");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵtemplate(7, PSMessagesComponent_a_7_Template, 2, 1, "a", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "div", 2);
        ɵngcc0.ɵɵelementStart(11, "div", 3);
        ɵngcc0.ɵɵelementStart(12, "h5", 9);
        ɵngcc0.ɵɵtext(13, "Message Response");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "div", 10);
        ɵngcc0.ɵɵelementStart(15, "div", 11);
        ɵngcc0.ɵɵelementStart(16, "button", 12);
        ɵngcc0.ɵɵtext(17, "Close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attachments);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.errorMessage, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: [ɵngcc6.NgForOf], encapsulation: 2 });
PSMessagesComponent.ctorParameters = () => [
    { type: PsMessagesService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PSMessagesComponent, [{
        type: Component,
        args: [{
                selector: 'ps-messages',
                template: "<div id=\"attachmentModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"attachmentModalTitle\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header d-none\">\n                <h5 class=\"modal-title\" id=\"attachmentModalTitle\">Attachments</h5>\n            </div>\n            <div class=\"modal-body\">\n                <a *ngFor=\"let attachment of attachments\" [href]=\"attachment.url\" target=\"_blank\" (click)=\"attachmentSelected()\" class=\"btn btn-secondary btn-block mb-1\">View Attachment</a>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id=\"errorModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"errorModalTitle\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header d-none\">\n                <h5 class=\"modal-title\" id=\"errorModalTitle\">Message Response</h5>\n            </div>\n            <div class=\"modal-body\" [innerHTML]=\"errorMessage\">\n                \n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button>\n            </div>            \n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: PsMessagesService }]; }, null); })();

class PSCoreNg {
    static forRoot() {
        return {
            ngModule: PSCoreNg,
            providers: [
                PsHttp,
                PsHttpFactory,
                SettingsService,
                PsForm,
                UserAppsService,
                UserAppsData,
                PsFormDependenciesService,
                PsMessagesService,
                UserService
            ],
        };
    }
}
PSCoreNg.ɵfac = function PSCoreNg_Factory(t) { return new (t || PSCoreNg)(); };
PSCoreNg.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PSCoreNg });
PSCoreNg.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            TranslateModule,
            CoreNg,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PSCoreNg, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    TranslateModule,
                    CoreNg,
                ],
                declarations: [PSMessagesComponent],
                exports: [PSMessagesComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PSCoreNg, { declarations: function () { return [PSMessagesComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        CoreNg]; }, exports: function () { return [PSMessagesComponent]; } }); })();

/*
 * Public API Surface of ps-core-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PSCoreNg, PsForm, PsFormComponent, PsHttp, PsHttpFactory, PsMessagesService, SettingsService, UserAppsData, UserAppsService, UserService, PSMessagesComponent as ɵa, PsFormDependenciesService as ɵb };

